<template>
  <el-dialog
    :visible.sync="visible"
    :title="$t('txmis.rebateComponents.tradeLogList')"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="70%"
  >
    <table-page ref="childTable" @getTableData="getTableData" :pageData="pageData"></table-page>

    <template slot="footer">
      <el-button @click="visible = false">{{$t('txmis.rebateComponents.cancel')}}</el-button>
    </template>
  </el-dialog>
</template>

<script>
    import tablePage from '@/components/page/table.vue'
    import URL from '@/views/newmis36/util/url';
    import DateUtil from '@/utils/IM/tradeDataUtil.js'
    import Qs from 'qs';

    let symbolType = {"2": "外汇", "1": "贵金属", "5": "指数", "4": "商品", "-1": "不限产品","100": "非虚拟币", "7": "股票", "6": "货币"};
    export default {
        components: {
            tablePage
        },
        data() {
            return {
                visible: false,
                queryData: {},
                tableData: [],
                detailAmount: 0,
                /*table生成*/
                pageData: {
                    queryUrl: URL.tradingRebate.tradeLogList, //请求路径和参数
                    selection: true,
                    sequence: true,
                    cols: [
                        {
                            title: window.$t('txmis.rebateComponents.symbolType'), field: 'symbolType', render: (data, full) => {
                                return symbolType[data] || "";
                            }
                        },
                        {title: window.$t('txmis.rebateComponents.displayName'), field: 'displayName'},
                        {title: window.$t('txmis.rebateComponents.orderId'), field: 'orderId'},
                        {title: window.$t('txmis.rebateComponents.execVolume'), field: 'execVolume'},
                        {
                            title: window.$t('txmis.rebateComponents.rebateAmount'), field: 'execVolume1', render: (data, full) => {
                                return full.execVolume * 10000 * this.detailAmount / 10000 || "";
                            }
                        }
                    ]
                }
            }
        },
        computed: {},

        methods: {
            init(row) {
                this.visible = true;
                if (row) {
                    this.queryData.ids = row.tradeIds;
                    if (DateUtil.isNotEmpty(row.currentRebete) && DateUtil.isNotEmpty(row.execVolume)) {
                        this.detailAmount = DateUtil.accDiv(row.currentRebete, row.execVolume);
                    }
                }
                this.$nextTick(() => {
                    if (this.queryData.ids) {
                        this.$refs.childTable.defaultGetData(this.queryData);
                    }
                })
            },
            getTableData(tableData) {
                this.tableData = tableData;
            },
        }
    };
</script>
